import { useQuery } from '@apollo/client';
import Grid from '@mui/material/Grid';
import PropTypes from 'prop-types';
import React, { useCallback } from 'react';
import RefreshButton from '../../../components/buttons/RefreshButton';
import CESSIONS_SUMMARY from '../../../graphql/queries/cessions-summary';
import useSelectedCompany from '../../../hooks/useSelectedCompany';
import OperationsStatusSummary from './OperationsStatusSummary';
import OperationsSummaryActions from './OperationsSummaryActions';

const OperationsStatusFilter = ({
  getCards,
  showSurplus,
  showRefreshButton,
  onRefresh,
  refreshLoading,
}) => {
  const selectedCompany = useSelectedCompany();
  const { data, loading, refetch } = useQuery(CESSIONS_SUMMARY, {
    variables: { companyId: selectedCompany?.id },
    skip: !selectedCompany,
    notifyOnNetworkStatusChange: true,
  });
  const handleRefresh = useCallback(() => {
    // Refresh both the main data and the summary data
    onRefresh();
    refetch();
  }, [onRefresh, refetch]);

  return (
    <>
      <OperationsStatusSummary
        getCards={getCards}
        summary={data?.cessionsSummary}
        loading={loading}
        extraComponents={<OperationsSummaryActions showSurplus={showSurplus} />}
      />
      {showRefreshButton && onRefresh && (
        <Grid item xs={12}>
          <RefreshButton
            onRefresh={handleRefresh}
            loading={refreshLoading}
            id="operations-status-filters-refresh"
            shouldLoadNewInvoices={false}
          />
        </Grid>
      )}
    </>
  );
};

OperationsStatusFilter.propTypes = {
  getCards: PropTypes.func.isRequired,
  showSurplus: PropTypes.bool,
  showRefreshButton: PropTypes.bool,
  onRefresh: PropTypes.func,
  refreshLoading: PropTypes.bool,
};

OperationsStatusFilter.defaultProps = {
  showSurplus: false,
  showRefreshButton: false,
  onRefresh: undefined,
  refreshLoading: false,
};

export default OperationsStatusFilter;
